import reviews from './data'
import gsap from 'gsap'
import imagesLoaded from 'imagesloaded'
import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar'
import Swiper, { Pagination, Navigation } from 'swiper'
import images from './helper/images'
import sounds from '../sounds/bubble.mp3'


const bar = document.querySelector('.loading__bar--inner')
const counter_num = document.querySelector('.loading__counter--number')
let c = 0

// disable horizontal scrolling
class DisableScrollPlugin extends ScrollbarPlugin {
  static pluginName = 'disableScroll';

  static defaultOptions = {
    direction: '',
  };

  transformDelta(delta) {
    if (this.options.direction) {
      delta[this.options.direction] = 0
    }

    return { ...delta }
  }
}

// load the plugin
Scrollbar.use(DisableScrollPlugin)

// hash anchors, prevent scrollbar from impacting it
class AnchorPlugin extends ScrollbarPlugin {
  static pluginName = 'anchor';

  onHashChange = () => {
    this.jumpToHash(window.location.hash)
  };

  onClick = (event) => {
    const { target } = event

    if (target.tagName !== 'A') {
      return
    }

    const hash = target.getAttribute('href')

    if (!hash || hash.charAt(0) !== '#') {
      return
    }

    this.jumpToHash(hash)
  };

  jumpToHash = (hash) => {
    const { scrollbar } = this

    if (!hash) {
      return
    }    

    // reset scrollTop
    scrollbar.containerEl.scrollTop = 0

    scrollbar.scrollIntoView(document.querySelector(hash))
  };

  onInit() {
    this.jumpToHash(window.location.hash)

    window.addEventListener('hashchange', this.onHashChange)

    this.scrollbar.contentEl.addEventListener('click', this.onClick)
  }

  onDestory() {
    window.removeEventListener('hashchange', this.onHashChange)

    this.scrollbar.contentEl.removeEventListener('click', this.onClick)
  }
}
// usage
Scrollbar.use(AnchorPlugin)


// Loading bar
const barInterval = setInterval(() => {
  bar.style.width = c + '%'
  counter_num.innerText = c + '%'
  c++
  if (c === 101) {
    clearInterval(barInterval)
    // same way use query selector
    gsap.to('.loading__bar', {
      duration: 5,
      rotate: '90deg',
      left: '1000%',
      top: '-500%',
    })
    // making div it disappear
    gsap.to('.loading__text, .loading__counter', {
      duration: 0.5,
      opacity: 0,
    })
    gsap.to('.loading__box', {
      duration: 1,
      // As width is 500px already
      height: '500px',
      borderRadius: '50%',
      border: '3px solid #6cff8c7a',
    })
    gsap.to('.loading__svg', {
      duration: 10,
      opacity: 1,
      rotate: '360deg',
    })
    gsap.to('.loading__box', {
      delay: 2,
      border: 'none',
    })
    // to make the images load before starting the site - slower connections
    imagesLoaded(document.querySelectorAll('img'), () => {
      gsap.to('.loading', {
        delay: 2,
        duration: 2,
        // This allows the other animations to work
        zIndex: 1,
        background: 'transparent',
        opacity: 0.3,
      })
      gsap.to('.loading__svg', {
        delay: 2,
        duration: 10,
        opacity: 1,
        rotate: '360deg',
        display: 'none',
      })
      // animations for when they display
      gsap.to('header', {
        delay: 2,
        duration: 3,
        top: 0,
      })
      gsap.to('.socials', {
        delay: 2.5,
        duration: 2,
        bottom: '10rem',
      })
      gsap.to('.scrollDown', {
        delay: 3,
        duration: 3,
        bottom: '3rem',
      })
      //* this impacts parallax scrolling 
      setTimeout(() => {
        const options = {
          damping: 0.2,
          // for the scroll bar on the right
          alwaysShowTracks: true,
          // plugins to disable sideways scroll
          plugins: {
            disableScroll: {
              direction: 'x',
            },
          },
        }
        const pageSmoothScroll = Scrollbar.init(document.body, options)
        // remove horizontal
        pageSmoothScroll.track.xAxis.element.remove()
      }, 2000)
    })
  }
}, 15)

// feedback swiper for reviews
// dependency array for swiper
Swiper.use([Pagination, Navigation])
var swiper = new Swiper('.swiper', {
  slidesPerView: 1,
  spaceBetween: 30,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  navigation: {
    // As it is a query selector, needs a . in the beginning
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  // responsive
  breakpoints: {
    850: {
      slidesPerView: 2,
    },
    1400: {
      slidesPerView: 2,
    },
    2000: {
      slidesPerView: 4,
    },
  },
})

const swiper_container = document.querySelector('.swiper-wrapper')
reviews.map((review) => {
  const template = `<div class="swiper-slide swiper-slide-active" style="width: 358px; margin-right: 30px"><div class="feedback"><svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" enable-background="new 0 0 32 32" viewBox="0 0 33 27" fill="none"><path fill="#6a0274" d="M12 13h-1.9854c.9287-2.6895 1.7217-3.9775 4.3604-5.0771.4404-.1836.6895-.6523.5957-1.1201C14.877 6.3359 14.4668 6 13.9902 6c-.001 0-.001 0-.002 0-5.5049.0098-8.667 2.2168-10.9092 7.6113C2.3633 15.3057 2 17.1191 2 19c0 2.8926.875 4.4678 2.209 6.541C4.3926 25.8271 4.71 26 5.0498 26H12c1.6543 0 3-1.3457 3-3v-7C15 14.3457 13.6543 13 12 13zM27 13h-1.9854c.9287-2.6895 1.7217-3.9775 4.3604-5.0771.4404-.1836.6895-.6523.5957-1.1201C29.877 6.3359 29.4668 6 28.9902 6c-.001 0-.001 0-.002 0-5.5049.0098-8.667 2.2168-10.9092 7.6113C17.3633 15.3057 17 17.1191 17 19c0 2.8926.875 4.4678 2.209 6.541C19.3926 25.8271 19.71 26 20.0498 26H27c1.6543 0 3-1.3457 3-3v-7C30 14.3457 28.6543 13 27 13z" class="color000 svgShape"/></svg><div class="feedback__card"><div class="feedback__topborder"></div>
  <div class="feedback__text">
  <p>${review.review.substring(0, review.review.length)}<p></div>
  <img src="${review.image}" alt="feedback avatar" class="feedback__img">
  <div class="feedback__profile"><span>${review.name}</span>
  <span>${review.position}</span></div></div></div></div>`
  // adds new review to template everytime one is added to previous
  swiper_container.innerHTML += template
})
// spread into make array, not nodelist. If new question is opened, old is removed from 'open' class
const questions = [...document.querySelectorAll('.question')]
questions.map((question) => {
  const q_text = question.querySelector('h3')
  question.addEventListener('click', () => {
    // if question is different to the question opened
    questions.filter((q) => q !== question).map((q) => q.classList.remove('open'))
    question.classList.toggle('open')
  })
})


function init () {
  // Elements
  const audio = document.querySelector('audio')
  audio.volume = 0.30
  const hexagons = document.querySelectorAll('.hexagon')
  hexagons.forEach(hex => hex.addEventListener('mouseover', playAudio))

  function playAudio(event){
    audio.src = `${sounds}`
    audio.play()
    console.log('sound playing')
  }

}
window.addEventListener('DOMContentLoaded', init)


